"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    centered: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3)
    },
    pointsEarned: {
        paddingBottom: theme.spacing(2),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    pointsEarnedDetails: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: theme.spacing(2)
    },
    titleText: {
        paddingBottom: theme.spacing()
    },
    pointsEarnedText: {
        paddingRight: theme.spacing(),
        fontWeight: 'bold'
    },
    newBalanceText: {
        textAlign: 'center',
        paddingBottom: theme.spacing(1)
    },
    newBalanceMessage: {
        textAlign: 'center',
        fontWeight: 'bold',
        paddingTop: theme.spacing(1)
    },
    campaignTitle: {
        textAlign: 'center',
        fontWeight: 'bold'
    },
    newPointsSection: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        borderRadius: '6px',
        backgroundColor: theme.palette.grey[200],
        [theme.breakpoints.down('xs')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4)
        }
    },
    pointsEarnedImg: {
        width: 90,
        [theme.breakpoints.down('xs')]: {
            width: 70
        }
    },
    button: {
        paddingTop: theme.spacing() + 2,
        paddingBottom: theme.spacing() + 2,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
    }
});
exports.default = styles;
//# sourceMappingURL=EarnPointsModalStyle.js.map